module.exports = __webpack_public_path__ + "static/ig_banner_02-9ac4ca8a551a34070c7c0030acfd7620.png";